export enum ImportStyle {
	Normal = 'NORMAL',
	Must = 'MUST',
	Fill = 'FILL',
	Skip = 'SKIP'
}
export interface ImportParam {
	After: string;
	Before: string;
	DB: string;
	Fields: ImportField[];
	Table: string;
	Where: string;
	NullIden: string;
}

export interface ImportField {
	Name: string;
	Alias: string;
	Remark: string;
	Style: ImportStyle;
	Value: string;
}
